import RemovePrompt from './RemovePrompt';
export default RemovePrompt;
